@let imageUrl = url();
@if (imageUrl) {
  <img
    class="tw:absolute tw:inset-0 tw:block tw:h-full tw:w-full tw:object-center tw:transition-opacity tw:duration-150 tw:ease-out tw:motion-reduce:transition-none"
    [class.tw:object-cover]="fit() === 'cover'"
    [class.tw:object-contain]="fit() === 'contain'"
    [class.tw:opacity-0]="status() !== 'loaded'"
    [src]="imageUrl"
    [alt]="alt()"
    [attr.loading]="lazy() ? 'lazy' : 'eager'"
    decoding="async"
    (load)="status.set('loaded')"
    (error)="status.set('error'); failed.emit()"
  />
}

@if (status() !== 'loaded') {
  <div
    class="ui-image__preview tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center tw:bg-[var(--ui-image-preview-bg,var(--color-gray-5))] tw:text-gray-2"
  >
    <ng-content select="[preview]">
      <fr8bot-ui-icon name="photo-camera-32" [size]="32" />
    </ng-content>
  </div>
}
